
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'the_impact_of_commonly_used_pregnant_women_medication_on_the_fetus',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/the_impact_of_commonly_used_pregnant_women_medication_on_the_fetus.vue